import {MaterialModal, MaterialModalOptions} from "./material-modal";
import {SwalUtils, ToastType, Utils} from "./Utils";

export class SignLeaseModal extends MaterialModal{
    private _studentNumber: string;
    private _studentRoom: number;
    private _studentLeaseAgreementId: number;
    private _building?: string;
    private _canvas: HTMLCanvasElement;
    // private _signBtn: HTMLButtonElement;
    private _jQuery = (window as any).$;

    constructor(modal: HTMLDivElement | string | undefined, options: SignLeaseModalOptions) {
        super(modal, options);
        this._studentNumber = options.studentNumber;
        this._studentRoom = options.studentRoom;
        this._studentLeaseAgreementId = options.studentLeaseAgreementId;
        this._building = options.building;
        const canvas = this.getElement<HTMLCanvasElement>('#can_pad');
        const signBtn = this.getElement<HTMLButtonElement>('#btn-sign');
        if(!canvas) throw new Error('Canvas not found');
        // if(!signBtn) throw new Error('Sign button not found');
        this._canvas = canvas;
        // this._signBtn = signBtn;

        // signBtn.addEventListener('click', () => {
        //     this.onSignClick(canvas);
        // });
    }

    onSignClick(canvas?: HTMLCanvasElement) {
        let image = (canvas ?? this._canvas).toDataURL("image/png");
        let url = '/api/leases/manager/sign/' + this._studentNumber;

        let data = {
            signature : image,
            studentRoom : this._studentRoom,
            leaseAgreementId: this._studentLeaseAgreementId
        }

        SwalUtils.showLoading('Sending Lease', 'Please wait while we send out the signed lease agreement');
        Utils.post(url, {
            body: data,
        }).then((r) => {
            SwalUtils.close();
            Utils.showToastMessage('Lease agreement signed successfully');
            this.close();
        }).catch((r) => {
            SwalUtils.close();
            Utils.showErrorToast('Failed to sign lease agreement', r);
        });
    }

    open(): Promise<void> {
        const superFunc = super.open.bind(this);
        return new Promise((resolve, reject) => {
            if(this._building) {
                //Hide the canvas
                this._canvas.style.display = 'none';
                //Show circular progress bar after canvas
                let progress = document.createElement('div');
                progress.classList.add('progress');
                let indeterminate = document.createElement('div');
                indeterminate.classList.add('indeterminate');
                progress.appendChild(indeterminate);
                this._canvas.parentElement?.appendChild(progress);

                let img = new Image();
                const _self = this;
                img.src = '/api/accommodation/buildings/signatures/' + this._building;
                img.onload = function () {
                    let ctx = _self._canvas.getContext('2d');
                    ctx?.drawImage(img, 0, 0);
                    _self._canvas.style.display = 'block';
                    progress.remove();
                    superFunc().then(resolve).catch(reject);
                }
                img.onerror = function () {
                    progress.remove();
                    _self._canvas.style.display = 'block';
                    // reject('Error loading signature pad');
                    Utils.showToastMessage('Error loading signature', ToastType.ERROR);
                    //Show modal anyway
                    superFunc().then(resolve).catch(reject);
                }
            }
        });
    }
}

export interface SignLeaseModalOptions extends MaterialModalOptions {
    studentNumber: string;
    studentRoom: number;
    studentLeaseAgreementId: number;
    building?: string;
}